import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    makerWrapper: {
        width: 56,
        height: 56,
        borderRadius: 56,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        cursor: "pointer",
        transform: "translate(-50%, -50%)"
    },
    markRect: {
        position: "absolute",
        left: 50,
        width: 54,
        height: 21,
        color: "#FFF",
        fontSize: 19,
        borderRadius: 2,
        fontWeight: "bold",
        display: "flex",
        justifyContent: "center",
    },
    markArrow: {
        position: "absolute",
        left: 42,
        width: 15,
        height: 15,
        transform: "rotate(45deg)",
        borderRadius: 2,
    },
    markContainer: {
        width: 13,
        height: 13,
        borderRadius: 13,
    }
}));

const VehicleMarker = ({ vehicleNumber, onClick, color = "#02489D" }: any) => {
    const classes = useStyles();
    return (
        <div onClick={onClick} className={classes.makerWrapper} style={{ backgroundColor: `${color}50` }}>
            <div className={classes.markContainer} style={{ backgroundColor: color }}></div>
            <div className={classes.markArrow} style={{ backgroundColor: color }}></div>
            <div className={classes.markRect} style={{ backgroundColor: color }}>{vehicleNumber}</div>
        </div>
    );
};

export default VehicleMarker;